import fleetTaskStatus from '../constants/fleet-task-status'
import * as Vehicle from '@/services/rest-api/lib/fleet-task/vehicle'
import * as Driver from '@/services/rest-api/lib/fleet-task/driver'
import * as FleetTaskUnion from '@/services/rest-api/lib/cost-management/fleet-task-union'

import { idFleetTaskStatusMapper } from '../constants/constants-mapper'
import moment from 'moment'
import store from '@/state/store'

export const FLEET_TASK_FIELD_NAME = 'fleet_task_id'

export const fleetTaskFieldsMixin = {
  methods: {
    async getFleetTask(queryParam) {
      const getList = FleetTaskUnion.get([
        `status.name in ${fleetTaskStatus.SCHEDULED.id} ${fleetTaskStatus.STARTED.id} ${fleetTaskStatus.ENDED.id}`,
      ])

      const response = await getList(queryParam)
      response.data.paginated_result = response.data.paginated_result.map((result) => ({
        ...result,
        status: {
          ...result.status,
          name: this.$t(idFleetTaskStatusMapper[result.status.name]),
        },
      }))

      return response
    },
  },
  computed: {
    fleetTaskFields() {
      return [
        {
          name: FLEET_TASK_FIELD_NAME,
          showKey: 'fleet_task',
          type: 'value-help-v2',
          label: this.$t('costManagement.form.fleetTaskNumber'),
          placeholder: `${this.$t('global.form.select')} ${this.$t(
            'costManagement.form.fleetTaskNumber'
          )}`,
          valueType: 'id',
          trackBy: 'number',
          displayedBy: 'name',
          listGetter: this.getFleetTask,
          hasStoreAction: false,
          tableFields: [
            {
              label: this.$t('fleetTask.fields.fleetTaskNumber'),
              name: 'fleetTaskNumber',
              key: 'number',
              isSortable: true,
              isRedirectable: true,
              isEditable: true,
              validation: 'required',
              thStyle: 'width: 350px',
            },
            {
              label: this.$t('fleetTask.fields.status'),
              name: 'status',
              key: 'status.name',
              isSortable: true,
              isRedirectable: true,
              isEditable: true,
              validation: 'required',
              thStyle: 'width: 350px',
              isSlot: true,
              slotComponent: () => import('@/router/views/cost-management/components/Field/Status'),
            },
            {
              label: this.$t('fleetTask.fields.departureTime'),
              name: 'departureDate',
              key: 'expected_departure_on',
              isSortable: true,
              isRedirectable: true,
              isEditable: true,
              validation: 'required',
              thStyle: 'width: 350px',
              formatter: (value) => {
                if (moment(value, moment.ISO_8601, true).isValid()) {
                  return moment(value).format('DD MMMM YYYY')
                }
                return ''
              },
            },
            {
              label: this.$t('fleetTask.fields.licensePlate'),
              name: 'licensePlate',
              key: 'vehicle.license_plate',
              isSortable: true,
              isRedirectable: true,
              isEditable: true,
              validation: 'required',
              thStyle: 'width: 350px',
            },
            {
              label: this.$t('fleetTask.fields.driver'),
              name: 'driver',
              key: 'driver_user.name',
              isSortable: true,
              isRedirectable: true,
              isEditable: true,
              validation: 'required',
              thStyle: 'width: 350px',
            },
          ],
          hide: () =>
            !store.getters['identity/hasAccessAll']([
              'tms:read',
              'tms:create',
              'tms:update',
              'tms:delete',
            ]),
        },
        {
          key: 'transaction_date',
          name: 'transaction_date',
          label: this.$t('costManagement.fields.transactionDate'),
          valueType: 'YYYY-MM-DD',
          type: 'date-picker',
          validation: 'required',
          format: 'DD MMMM YYYY',
        },
        {
          key: 'funds_account_source',
          name: 'funds_account_source',
          label: this.$t('costManagement.form.sourceOfFundsAccount'),
          placeholder: `${this.$t('global.form.enter')} ${this.$t(
            'costManagement.form.sourceOfFundsAccount'
          )}`,
          type: 'text',
        },
        {
          name: 'vehicle_id',
          showKey: 'vehicle',
          type: 'value-help-v2',
          label: this.$t('costManagement.form.licensePlate'),
          placeholder: `${this.$t('global.form.select')} ${this.$t(
            'costManagement.form.licensePlate'
          )}`,
          validation: 'required',
          valueType: 'id',
          trackBy: 'id',
          displayedBy: 'license_plate',
          listGetter: (queryParam) => {
            queryParam.filters = queryParam.filters ? queryParam.filters : []
            queryParam.filters.push('parent_only = true')

            return Vehicle.get(queryParam)
          },
          getInitialObject: (data) => data?.vehicle,

          tableFields: [
            {
              label: this.$t('costManagement.form.licensePlate'),
              key: 'license_plate',
              isSortable: true,
            },
            {
              label: this.$t('costManagement.form.driver'),
              key: 'driver.name',
              isSortable: true,
            },
          ],
          hasStoreAction: false,
        },
        {
          name: 'driver_id',
          showKey: 'driver',
          type: 'value-help-v2',
          label: this.$t('costManagement.form.driver'),
          placeholder: `${this.$t('global.form.select')} ${this.$t('costManagement.form.driver')}`,
          valueType: 'id',
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Driver.get,
          getInitialObject: (data) => data?.driver_user,
          hasStoreAction: false,
          tableFields: [
            {
              label: this.$t('costManagement.form.driver'),
              key: 'name',
              isSortable: true,
            },
          ],
        },
      ]
    },
  },
}
